<div class="oiq-ui-dialog onyxiq-theme-v2">
  <header>
    <div class="__title">
      <div>
        <h2>Notifications</h2>
      </div>
      <button
        (click)="event.emit({ type: 'close' })"
        class="oiq-button oiq-button--link __close"
        type="button">
        <span class="material-symbols-outlined">close</span>
      </button>
    </div>
  </header>
  <main style="padding: 0rem; overflow: hidden" class="flex flex-col gap-2 bg-gray-6">
    <div class="oiq-ui-tabs w-full px-4 pt-4">
      <button
        type="button"
        class="oiq-button active"
        [class.active]="activeTab === 'upcoming'"
        (click)="activeTab = 'upcoming'">
        Upcoming ({{ store.upcomingEventsTotal$ | async }})</button
      ><button
        type="button"
        class="oiq-button"
        [class.active]="activeTab === 'past'"
        (click)="activeTab = 'past'">
        Past ({{ store.pastEventsTotal$ | async }})</button
      ><button
        type="button"
        class="oiq-button"
        [class.active]="activeTab === 'future'"
        (click)="activeTab = 'future'">
        Future ({{ store.futureEventsTotal$ | async }})</button
      ><button
        type="button"
        class="oiq-button"
        [class.active]="activeTab === 'sms'"
        (click)="activeTab = 'sms'">
        SMS ({{ (smsAlertsStore.unreadCount$ | async)?.count ?? 0 }})
      </button>
      @if (activeTab === 'sms') {
        @let _smsAlerts = (smsAlertsStore.alerts$ | async) ?? [];
        <button
          type="button"
          class="oiq-button oiq-button--primary--link oiq-button--sm ml-auto shadow-none"
          [disabled]="!_smsAlerts.length"
          (click)="markAllSmsAlertsRead(_smsAlerts)">
          <span class="material-symbols-outlined text-sm">done_all</span>
          <span>Mark all read</span>
        </button>
      } @else {
        <button
          type="button"
          class="oiq-button oiq-button--primary--link oiq-button--sm ml-auto shadow-none"
          (click)="openEditCalendarEventDialog([])">
          <span class="material-symbols-outlined text-sm">add</span>
          <span>Add new</span>
        </button>
      }
    </div>
    @if (activeTab === 'upcoming') {
      <oiq-notification-events-list
        class="block flex-grow overflow-y-auto"
        [items]="store.upcomingEventsRows$ | async"
        (event)="handleEvent($event)"></oiq-notification-events-list>
    }
    @if (activeTab === 'past') {
      <oiq-notification-events-list
        class="block flex-grow overflow-y-auto"
        [items]="store.pastEventsRows$ | async"
        (event)="handleEvent($event)"></oiq-notification-events-list>
    }
    @if (activeTab === 'future') {
      <oiq-notification-events-list
        class="block flex-grow overflow-y-auto"
        [items]="store.futureEventsRows$ | async"
        (event)="handleEvent($event)"></oiq-notification-events-list>
    }
    @if (activeTab === 'sms') {
      @let _smsAlertRows = smsAlertsStore.alerts$ | async;
      @if (_smsAlertRows === null) {
        <div
          class="flex flex-grow items-center justify-center p-4"
          role="status"
          aria-label="Loading SMS replies">
          <span class="ph ph-spinner animate-spin text-2xl text-primary"></span>
        </div>
      } @else {
        <oiq-notification-sms-alerts-list
          class="block flex-grow overflow-y-auto"
          [items]="_smsAlertRows"
          [canOpen]="canOpenSmsAlerts"
          (event)="handleSmsAlertEvent($event)"></oiq-notification-sms-alerts-list>
      }
    }
  </main>
  <footer>
    <!--    <div class="flex w-full flex-col items-center justify-center">-->
    <!--      <button-->
    <!--        type="button"-->
    <!--        class="oiq-button oiq-button&#45;&#45;link"-->
    <!--        (click)="openEditCalendarEventDialog([])">-->
    <!--        +Add new-->
    <!--      </button>-->
    <!--    </div>-->
  </footer>
</div>
